import { render, staticRenderFns } from "./AppUpdateVersionModal.vue?vue&type=template&id=72567ad5&scoped=true&"
import script from "./AppUpdateVersionModal.vue?vue&type=script&lang=js&"
export * from "./AppUpdateVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateVersionModal.vue?vue&type=style&index=0&id=72567ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72567ad5",
  null
  
)

export default component.exports